import { Injectable } from '@angular/core';
import { Region } from '@models/Location/region.model';
import { Category } from '@models/SEO/category.model';

@Injectable()
export class StaticDataService {
  categories: Category[] = [];
  regions: Region[] = [
    {
      name: 'Aarhus',
      regionURL: 'aarhus',
      coordinates: { type: 'Point', coordinates: [10.195657, 56.154359] },
    },
    {
      name: 'Odense',
      regionURL: 'odense',
      coordinates: { type: 'Point', coordinates: [10.389232, 55.392889] },
    },
    {
      name: 'Storkøbenhavn',
      regionURL: 'storkoebenhavn',
      coordinates: { type: 'Point', coordinates: [12.524029, 55.682451] },
    },
    {
      name: 'Nordsjælland',
      regionURL: 'nordsjaelland',
      coordinates: { type: 'Point', coordinates: [12.301777, 55.870799] },
    },
    {
      name: 'Bornholm',
      regionURL: 'bornholm',
      coordinates: { type: 'Point', coordinates: [14.925935, 55.274639] },
    },
    {
      name: 'Vestsjælland',
      regionURL: 'vestsjaelland',
      coordinates: { type: 'Point', coordinates: [11.354849, 55.406263] },
    },
    {
      name: 'Sydsjælland og øer',
      regionURL: 'sydsjaelland-og-oeer',
      coordinates: { type: 'Point', coordinates: [11.903353, 55.028908] },
    },
    {
      name: 'Fyn',
      regionURL: 'fyn',
      coordinates: { type: 'Point', coordinates: [10.378113, 55.310307] },
    },
    {
      name: 'Sønderjylland',
      regionURL: 'soenderjylland',
      coordinates: { type: 'Point', coordinates: [9.125097, 55.359493] },
    },
    {
      name: 'Midt/Vestjylland',
      regionURL: 'midtvestjylland',
      coordinates: { type: 'Point', coordinates: [8.914974, 56.290146] },
    },
    {
      name: 'Nordjylland',
      regionURL: 'nordjylland',
      coordinates: { type: 'Point', coordinates: [9.680711, 56.983917] },
    },
    {
      name: 'Østjylland',
      regionURL: 'oestjylland',
      coordinates: { type: 'Point', coordinates: [9.995557, 56.185081] },
    },
  ];
  constructor() {}
}
